module.exports = __webpack_public_path__ + "static/atinuke-0c7f29ddcab1c1e5368ec79b0f2158eb.jpg";